import React from 'react'

const TableSakinah = ({ dataTable = [], yearconfig = new Date().getFullYear(), loading = false }) => {
    const triwulan = ["tw1", "tw2", "tw3", "tw4"]
    function formatAngka(num) {
        try {
            num = Number(num)
            return Number(num.toFixed(2));
        } catch (error) {
            console.log(num);
            
            return "Nan"
        }
        
    }
    return (
        <div className="w-full sm:overflow-visible overflow-x-auto flex flex-col justify-center">
            <table className="w-full table-auto text-xs mb-4">
                <thead className="bg-primeColor1 text-white sticky top-0">
                    <tr>
                        <th className="border border-slate-500  w-[3%]" rowSpan={3}>
                            No
                        </th>
                        <th className="border border-slate-500 md:w-1/4" rowSpan={3}>
                            Indikator
                        </th>
                        <th className="border border-slate-500 w-[10%]" rowSpan={3}>
                            Satuan
                        </th>
                        <th className="border border-slate-500" colSpan={triwulan.length * 3}>
                            Tahun {yearconfig}
                        </th>
                    </tr>
                    <tr>
                        {
                            triwulan.map((item, index) => {
                                return (
                                    <th className="border border-slate-500" colSpan={3}>
                                        <span className="md:block hidden">{`Triwulan ${index+1}`}</span>
                                        <span className="md:hidden block">{`Tw ${index+1}`}</span>
                                    </th>
                                )
                            })
                        }
                    </tr>
                    <tr>
                        {
                            triwulan.map((item, key) => {
                                return (
                                    <>
                                        <th className="border border-slate-500" key={key}>
                                            <span className="md:block hidden">Target</span>
                                            <span className="md:hidden block">T</span>
                                        </th>
                                        <th className="border border-slate-500">
                                            <span className="md:block hidden">Realisasi</span>
                                            <span className="md:hidden block">R</span>
                                        </th>
                                        <th className="border border-slate-500">
                                            <span className="md:block hidden">Capaian</span>
                                            <span className="md:hidden block">C</span>
                                        </th>
                                    </>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        !loading ?  
                        dataTable.length > 0 ? 
                        dataTable.map((item1, key1) => {
                            return (
                                item1.indikator_sasaran.length > 0 ? 
                                    item1.indikator_sasaran.map((item2, key2) => (
                                        <>
                                            {
                                                key2 == 0 ?
                                                <tr>
                                                    <td className="border border-slate-500 font-semibold py-2 px-5 bg-green-200" colSpan="100%">{item1.sasaran}</td>
                                                </tr> : null
                                            }
                                            <tr>
                                                <td className="border border-slate-500 py-2 px-5 align-baseline">{key2+1}</td>
                                                <td className="border border-slate-500 py-2 px-5 align-baseline">{item2.indikator ?? "-"}</td>
                                                <td className="border border-slate-500 py-2 px-5 text-center">{item2.satuan ?? "-"}</td>
                                                {
                                                    triwulan.map((item) => {
                                                        return (
                                                            <>
                                                                <td className="border border-slate-500 p-2 text-center">{item2[`target_${item}`] ?? ""}</td>
                                                                <td className="border border-slate-500 p-2 text-center">{item2[`realisasi_${item}`] ?? ""}</td>
                                                                <td className="border border-slate-500 p-2 text-center">{formatAngka(item2[`capaian_${item}`] ?? "")}</td>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </>
                                    ))
                                :
                                <tr>
                                    <td className="border border-slate-500 py-2 px-5 bg-green-200 text-center" colSpan="100%">No Data</td>
                                </tr>
                            )
                        })
                        :
                        <tr>
                            <td className="border border-slate-500 py-2 px-5 bg-green-200 text-center" colSpan="100%">No Data</td>
                        </tr>
                        : 
                        <tr>
                            <td className="border border-slate-500 py-2 px-5 bg-green-200 text-center" colSpan="100%">Loading...</td>
                        </tr>
                    }
                </tbody>
            </table>
            <span className="text-red-400 text-xs font-bold">
                Sumber : <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; *) Realisasi Rencana Aksi Perangkat Daerah Aplikasi Sakinah
            </span>
        </div>
    )
}

export default TableSakinah